/* eslint-disable default-case */
import React from 'react';
import strings from 'utils/strings';
import './styles.scss';
import moment from 'moment';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

import {updateObject} from '../../../utils/reducerUtils';
import addMomentsToTestResults from '../../../utils/addMomentsToTestResults';
import getBatchedTestResults from '../../../utils/getBatchedTestResults';

import getGroupedTestAdminClassResults from '../../../api/getGroupedTestAdminClassResults';
import getAllClasses from '../../../api/getAllClasses';
import deleteClasses from '../../../api/deleteClasses';
import addClassesToGroup from '../../../api/addClassesToGroup';
import roundWithDecimals from 'utils/roundWithDecimals';
import updateLogEvent from 'api/updateLogEvent';
import InformationPane from '../../../components/InformationPane';
import getTestsAverageScore from 'api/getTestsAverageScore';

import {
	COMPLETED,
	DISTRIBUTED,
	NOT_STARTED,
	STARTED,
	TEST_TYPES,
	TEST_TYPE_NAMES,
} from 'constants/index';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
	faPlus,
	faTrash,
	faChartColumn,
} from '@fortawesome/free-solid-svg-icons';
import RenderSubTableModal from './renderSubTableModal';

const processTestResults = (testResults, recentKey) => {
	const testResultsWithStatus = testResults.map((testResult) => {
		let status;
		if (testResult.completedAt) {
			status = COMPLETED;
		} else if (testResult.usedAt) {
			status = STARTED;
		} else if (testResult.distributedAt) {
			status = DISTRIBUTED;
		} else {
			status = NOT_STARTED;
		}

		return updateObject(testResult, {
			status,
		});
	});

	const testResultsWithMoments = addMomentsToTestResults(
		testResultsWithStatus
	);

	const batchedTestResults = getBatchedTestResults(testResultsWithMoments);
	return batchedTestResults;
};

const childTypes = [
	TEST_TYPES.CHILD_FOLLOWUP,
	TEST_TYPES.YOUTH_FOLLOWUP,
	TEST_TYPES.ADULT_FOLLOWUP,
];

const allMyClasses = 'Alla mina klasser';
let sortOrder = true;
class MyClasses extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isMainChecked: false,
			singleChecks: false,
			selectedClass: '',
			isGroupPanelActive: false,
			allMyClasses: '',
			individualCandidates: [],
			selectedClasses: [],
			customTableClass: 'lit-myClass_grid',
			allClassData: this.props.classData,
			selectedClassData: this.props.classData,
			audioData: [],
			groupClassData: [],
			timeOut: false,
			silence: true,
			renderPaneAlert: false,
			selectedGroup: null,
			groupTestResults: [],
			isAddingClassToGroup: false,
			hasRelevantClasses: false,
			selectedType: null,
			showSubTableModal: false,
			paneMessage: '',
		};
		this.handleClick = this.handleClick.bind(this);
	}
	componentDidMount() {
		let hasRelevantClasses = false;

		for (let i = 0; i < this.state.allClassData.length; i++) {
			if (
				!this.state.allClassData[i].groupId ||
				this.state.allClassData[i].ownsClass
			) {
				hasRelevantClasses = true;
				break;
			}
		}

		this.setState({allMyClasses: allMyClasses, hasRelevantClasses});
		this.fetchAndRefreshAdminClasses();
	}
	componentWillReceiveProps() {
		let hasRelevantClasses = false;
		if (!this.state.isGroupPanelActive) {
			for (let i = 0; i < this.props.classData.length; i++) {
				if (
					!this.props.classData[i].groupId ||
					this.props.classData[i].ownsClass
				) {
					hasRelevantClasses = true;
					break;
				}
			}
			this.setState({
				allMyClasses: this.state.allMyClasses,
				hasRelevantClasses,
				selectedClassData: this.props.classData,
			});
		} else {
			const newClassData = [];
			for (let i = 0; i < this.props.classData.length; i++) {
				if (
					this.props.classData[i].groupId &&
					this.state.selectedGroup[0].id ===
						this.props.classData[i].groupId
				) {
					newClassData.push(this.props.classData[i]);
					hasRelevantClasses = true;
				}
			}
			this.setState({
				allMyClasses,
				isGroupPanelActive: true,
				hasRelevantClasses: hasRelevantClasses,
				selectedClassData: newClassData,
				groupClassData: newClassData,
				isAddingClassToGroup: false,
			});
		}
	}

	deleteSelectedClasses(extractedIds, subsId) {
		deleteClasses(extractedIds, subsId).then(() => {
			getAllClasses().then((classData) => {
				const adminClasses = classData.map((usersClass) => ({
					className: usersClass.className,
					classId: usersClass.classId,
				}));
				this.setState({
					selectedClassData: classData,
					allClassData: classData,
				});
			});
		});
	}

	fetchAndRefreshAdminClasses() {
		getAllClasses().then((classData) => {
			var selectedClassData = classData;
			const uncheckedClassData = [];
			for (let i = 0; i < selectedClassData.length; i++) {
				if (selectedClassData[i].checked) {
					selectedClassData[i].checked = false;
				}
				uncheckedClassData.push(selectedClassData[i]);
			}

			this.setState({
				selectedClassData: uncheckedClassData,
				allClassData: uncheckedClassData,
				isAddingClassToGroup: false,
			});
		});
	}

	getAndSetAdminClasses() {
		getAllClasses().then((classData) => {
			var selectedClassData = classData;
			const uncheckedClassData = [];
			for (let i = 0; i < selectedClassData.length; i++) {
				if (selectedClassData[i].checked) {
					selectedClassData[i].checked = false;
				}

				uncheckedClassData.push(selectedClassData[i]);
			}

			this.setState({
				selectedClassData: uncheckedClassData,
				allClassData: uncheckedClassData,
				paneMessage: strings.classAddedToGroup,
				renderPaneMessage: true,
				isAddingClassToGroup: false,
			});
		});
	}
	addSelectedClassesToGroup(classIds, groupIds) {
		if (!Array.isArray(classIds) || !classIds.length || !groupIds) {
			this.setState({
				renderPaneAlert: true,
				paneMessage: 'Velg minst én klasse og én gruppe.',
			});
			return;
		}

		const groupedClasses = {classIds, groupIds};

		addClassesToGroup(groupedClasses).then(() => {
			this.getAndSetAdminClasses();
		});
	}

	handleClick = (id, key) => {
		this.updateViewLog(id, key);
	};

	updateViewLog(id, key) {
		updateLogEvent('view', id, key, 'Results').then(() => {});
	}

	getAndSetTestCandidatesAverageScore(testData, classData) {
		const {currentUser} = this.props;
		const id = currentUser.id;
		return getTestsAverageScore(testData).then((averageZScore) => {
			return new Promise((resolve) => {
				classData.averageZscore = roundWithDecimals(averageZScore, 4);
				this.setState(
					{
						averageZScore,
					},
					resolve
				);
			});
		});
	}

	sortTableBy(identifier) {
		const {selectedClassData} = this.state;
		sortOrder = !sortOrder;
		switch (identifier) {
			case 'name':
				selectedClassData.sort(this.compareByName);
				break;
			case 'candidates':
				selectedClassData.sort(this.compareBytests);
				break;
		}
		this.setState({selectedClassData});
	}

	compareByName(a, b) {
		if (!sortOrder) {
			if (a.className.toLowerCase() < b.className.toLowerCase()) {
				return 1;
			}
			if (a.className.toLowerCase() > b.className.toLowerCase()) {
				return -1;
			}
			return 0;
		}
		if (a.className.toLowerCase() > b.className.toLowerCase()) {
			return 1;
		}
		if (a.className.toLowerCase() < b.className.toLowerCase()) {
			return -1;
		}
		return 0;
	}
	compareBytests(a, b) {
		if (!sortOrder) {
			if (a.strength < b.strength) {
				return 1;
			}
			if (a.strength > b.strength) {
				return -1;
			}
			return 0;
		}
		if (a.strength > b.strength) {
			return 1;
		}
		if (a.strength < b.strength) {
			return -1;
		}
		return 0;
	}
	renderCustomTableHeader() {
		return (
			<div>
				<div className="lit-myClass-header_grid">
					<div className="lit-myClass-header-wrapper">
						<div className="checkbox-wrapper-13">
							<input
								type="checkbox"
								disabled
								className="lit_cb_users"
								id="main_checkbox"
								onChange={(e) => {
									if (e.target.checked) {
										const checkedClassData =
											this.state.selectedClassData.map(
												(data) => {
													data.checked = true;
													return data;
												}
											);

										this.setState({
											isMainChecked: true,
											selectedClassData: checkedClassData,
										});
									} else {
										const checkedClassData =
											this.state.selectedClassData.map(
												(data) => {
													data.checked = false;
													return data;
												}
											);

										this.setState({
											isMainChecked: false,
											selectedClassData: checkedClassData,
										});
									}
								}}
							/>
						</div>

						<div className="myClass_table-title-header">
							<span
								className="className-title"
								onClick={() => {
									this.sortTableBy('name');
								}}
							>
								{`Namn på klassen`}
							</span>
						</div>
						<div className="myClass_table-title-header">
							<span
								className="total-candidates"
								onClick={() => {
									this.sortTableBy('candidates');
								}}
							>
								{`Antal kandidater`}
							</span>
						</div>
						<div
							className="myClass_table-title-header"
							onClick={() => {
								/* this.sortTableBy('tests'); */
							}}
						>
							<span>Genomförda tester</span>
						</div>
						<div className="myClass_table-title-header">
							<span>Genomsnittligt Z-värde</span>
						</div>
						<div className="myClass_table-title-header" />
					</div>
				</div>
			</div>
		);
	}
	renderCustomTable(classData) {
		return (
			<div>
				<div
					className="lit-myClass_grid"
					id={classData.className}
					onClick={() => {
						classData.active = true;
						this.setState({
							showSubTableModal: true,
							selectedClass: classData.className,
							selectedType: null,
						});
					}}
				>
					{!this.state.isMainChecked && !this.state.singleChecks && (
						<div
							className="checkbox-wrapper-13"
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							<input
								type="checkbox"
								key={classData.classId}
								className="lit_cb_users"
								checked={Boolean(classData.checked)}
								disabled={!classData.ownsClass}
								id={3}
								onChange={(e) => {
									const checked = e.target.checked;

									this.setState((prevState) => ({
										selectedClassData:
											prevState.selectedClassData.map(
												(item) =>
													item.classId ===
													classData.classId
														? {...item, checked}
														: item
											),
										allClassData:
											prevState.allClassData.map(
												(item) =>
													item.classId ===
													classData.classId
														? {...item, checked}
														: item
											),
										isAddingClassToGroup: false,
										selectedClasses: [],
										groupId: null,
									}));
								}}
							/>
						</div>
					)}
					{this.state.isMainChecked && (
						<div
							className="checkbox-wrapper-13"
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							<input
								type="checkbox"
								className="lit_cb_users"
								defaultChecked
								id={4}
								onChange={(e) => {
									if (e.target.checked) {
										classData.checked = true;
										this.setState({
											selectedClassData:
												this.props.classData,
										});
									} else {
										classData.checked = false;
										this.setState({
											selectedClassData:
												this.props.classData,
										});
									}
								}}
							/>
						</div>
					)}
					<div className="myClass_name_table-cell">
						{classData.className}
					</div>
					<div className="myClass_name_table-cell">
						{classData.strength}
					</div>
					<div className="myClass_name_table-cell">
						{this.calculateCompletedTests(
							classData.classInfo,
							this.props.batchedFilteredTestResults
						)}
					</div>
					<div className="myClass_name_table-cell">
						<span
							className="lit-average-zs"
							onClick={(event) => {
								event.stopPropagation();
								const someData = this.getFilteredTestUsers(
									classData.classInfo,
									this.props.batchedFilteredTestResults
								);
								const testData = someData.map((data) => {
									return {
										id: data.id,
										type: data.type,
										key: data.key,
									};
								});
								this.getAndSetTestCandidatesAverageScore(
									testData,
									classData
								);
							}}
						>
							{classData.averageZscore}
						</span>
					</div>
					<div className="myClass_name_table-cell-expand-btn">
						<div className="lit-list__text">
							<button className="lit-btn lit-btn--small bg-primary5">
								<span>{'Se Tester'}</span>
							</button>
						</div>
					</div>
				</div>
				{classData.active === true && this.state.showSubTableModal && (
					<RenderSubTableModal
						closeWindow={() => {
							classData.active = false;

							this.setState({
								showSubTableModal: false,
							});
						}}
						selectedClass={this.state.selectedClass}
					>
						{this.renderSubTable(
							this.getFilteredTestUsers(
								classData.classInfo,
								this.props.batchedFilteredTestResults
							),
							classData.classInfo
						)}
					</RenderSubTableModal>
				)}
			</div>
		);
	}
	calculateCompletedTests(classInfo, allTestUsers) {
		const allUsers = classInfo.map((data) => {
			return data.candidateId;
		});

		if (!this.state.isGroupPanelActive) {
			const tempObj = [];
			for (let i = 0; i < allTestUsers.length; i++) {
				const testsResults = allTestUsers[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}
			const count = tempObj.filter(
				(singleInstance) => singleInstance.completedAt
			).length;

			return `${count}/${tempObj.length}`;
		} else if (
			this.state.isGroupPanelActive &&
			this.state.groupTestResults.length
		) {
			const {groupTestResults} = this.state;
			const tempObj = [];

			for (let i = 0; i < groupTestResults.length; i++) {
				const testsResults = groupTestResults[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}
			const count = tempObj.filter(
				(singleInstance) => singleInstance.completedAt
			).length;

			return `${count}/${tempObj.length}`;
		}
	}

	renderSubTable(singleCandidate, classInfoResults) {
		if (!singleCandidate) {
			return (
				<div className="mcx-drawer">
					<p>Denne klassen inneholder ingen testresultater</p>
				</div>
			);
		}
		const mapA = classInfoResults.reduce((acc, item) => {
			acc[item.candidateId] = item.subTestsResults;
			return acc;
		}, {});
		singleCandidate.forEach((item) => {
			const testUserId = item.testUser?.testUserId;
			item.subTestsResults = mapA[testUserId] || [];
		});
		const testType = singleCandidate[0].type || null;

		// ✅ detect available types
		const hasScreening = singleCandidate.some((c) =>
			c.type.includes('screening')
		);
		const hasFollowup = singleCandidate.some((c) =>
			c.type.includes('followup')
		);

		// ✅ determine correct selectedType
		let selectedType = this.state.selectedType;

		// if not set OR invalid → fix it
		if (
			!selectedType ||
			(selectedType === 'screening' && !hasScreening) ||
			(selectedType === 'followup' && !hasFollowup)
		) {
			selectedType = hasScreening ? 'screening' : 'followup';

			// sync state (important)
			if (selectedType !== this.state.selectedType) {
				this.setState({selectedType});
			}
		}
		const SCREENING_TESTS = [1, 2, 3, 4, 5, 6];
		const FOLLOWUP_TESTS = [0, 3, 4, testType === 'child-followup' ? 8 : 5];

		const tests =
			selectedType === 'screening' ? SCREENING_TESTS : FOLLOWUP_TESTS;

		// helper: map results by test
		const getTestMap = (results = []) => {
			const map = {};

			results.forEach((r) => {
				const existing = map[r.test];

				if (!existing) {
					map[r.test] = r;
				} else if (
					new Date(r.createdAt) < new Date(existing.createdAt)
				) {
					map[r.test] = r;
				}
			});
			return map;
		};
		const SCREENING_TEST_NAMES = {
			1: strings.worddictationtest,
			2: strings.wordchaintest,
			3: testType.includes('child')
				? strings.swapsoundtest
				: strings.nonwordtest,
			4: strings.typingspeedtest,
			5: strings.readingtest,
			6: strings.wordcomprehensiontest,
		};

		const FOLLOWUP_TEST_NAMES_AND_TYPES = {
			adultyouth: {
				0: strings.workingmemorytest,
				3: strings.rapidautonamingtest,
				4: strings.oneminute,
				5: strings.spoonerism,
			},
			child: {
				0: strings.workingmemorytest,
				3: strings.rapidautonamingtest,
				4: strings.oneminutetest,
				8: strings.phonemeomissiontest,
			},
		};

		const testNames =
			selectedType === 'screening'
				? SCREENING_TEST_NAMES
				: FOLLOWUP_TEST_NAMES_AND_TYPES[
						testType.includes('child') ? 'child' : 'adultyouth'
					];
		return (
			<div className="mcx-drawer">
				{/* ✅ FILTER DROPDOWN */}
				<div className="mcx-filter-bar">
					<label className="mcx-filter-label">{strings.type}</label>

					<div className="mcx-select-wrapper">
						<select
							className="mcx-select"
							value={selectedType || ''}
							onChange={(e) =>
								this.setState({
									selectedType: e.target.value,
								})
							}
						>
							{/* ✅ show only if exists */}
							{hasScreening && (
								<option value="screening">
									{strings.screeningTest}
								</option>
							)}

							{hasFollowup && (
								<option value="followup">
									{strings.followUpTest}
								</option>
							)}
						</select>
					</div>
				</div>
				<div className="mcx-legend">
					<div className="mcx-legend-item">
						<span className="mcx-legend-dot red" />
						{strings.redAverageArea}
					</div>

					<div className="mcx-legend-item">
						<span className="mcx-legend-dot yellow" />
						{strings.yellowAverageArea}
					</div>

					<div className="mcx-legend-item">
						<span className="mcx-legend-dot green" />
						{strings.greenAverageArea}
					</div>
				</div>
				<div className="mcx-tests-wrapper">
					{/* HEADER */}
					<div className="mcx-tests__header">
						<div>{strings.testCandidate}</div>

						<div>{strings.status}</div>
						{tests.map((t) => (
							<div key={t}>{testNames[t]}</div>
						))}
						<div className="mcx-actions-header">
							{strings.resultsReport}
						</div>
					</div>

					{/* ROWS */}
					<ul className="mcx-tests">
						{singleCandidate
							.filter((c) =>
								selectedType
									? c.type.includes(selectedType)
									: true
							)
							.map((c) => {
								const {
									id,
									key,
									testUser,
									status,
									type,
									createdAt,
									completedAt,
									usedAt,
									distributedAt,
									subTestsResults,
								} = c;

								const fullName = testUser
									? `${testUser.firstName} ${testUser.lastName}`
									: '';

								const fmt = (d) => moment(d).format('DD.MM.YY');

								let label = '';
								let date = '';

								if (completedAt) {
									label = strings.completed;
									date = fmt(completedAt);
								} else if (usedAt) {
									label = strings.started;
									date = fmt(usedAt);
								} else if (distributedAt) {
									label = strings.distributed;
									date = fmt(distributedAt);
								} else if (createdAt) {
									label = strings.createdOn;
									date = fmt(createdAt);
								}

								return (
									<li className="mcx-testrow" key={key}>
										<div className="mcx-col">
											{fullName || (
												<b>{strings.notdistributed}</b>
											)}
										</div>
										<div className="mcx-col mcx-status">
											<div className="mcx-col mcx-status">
												{label && (
													<div className="lit-test__date">
														<div className="lit-test__label">
															{label}
														</div>
														<div className="lit-test__value">
															{date}
														</div>
													</div>
												)}
											</div>
										</div>

										{(() => {
											const testMap =
												getTestMap(subTestsResults);

											return tests.map((testNum) => {
												const t = testMap[testNum];

												let colorClass =
													'mcx-cell-gray';

												if (t) {
													if (t.zScore < -1)
														colorClass =
															'mcx-cell-red';
													else if (t.zScore <= 1)
														colorClass =
															'mcx-cell-yellow';
													else
														colorClass =
															'mcx-cell-green';
												}

												return (
													<div
														key={testNum}
														className={`mcx-col mcx-cell ${colorClass}`}
													>
														{t
															? t.zScore.toFixed(
																	2
																)
															: '-'}
													</div>
												);
											});
										})()}

										<div className="mcx-col mcx-actions">
											{this.renderButton(
												type,
												id,
												status,
												key
											)}
										</div>
									</li>
								);
							})}
					</ul>
				</div>
			</div>
		);
	}

	renderButton(type, id, status, key) {
		const completed = status === COMPLETED;
		const started = status === STARTED;
		const isChildType = childTypes.includes(type);

		const destination = isChildType
			? `/single-child-test/${id}`
			: `/single-test/${id}`;

		if (completed || started) {
			return (
				<div className="table-action">
					<Link
						className="icon-btn"
						to={destination}
						onClick={() => this.handleClick(id, key)}
						target="_blank"
						rel="noopener noreferrer"
					>
						<FontAwesomeIcon icon={faChartColumn} />
					</Link>
				</div>
			);
		}
		return null;
	}
	getTestDateInfo(completedAt, usedAt, distributedAt) {
		let testDateInfo;
		if (completedAt) {
			testDateInfo = (
				<td className="lit-test__col">
					<p className="lit-test-no-margin">
						{strings.completed}
						<br />
						{moment(completedAt).format('LLL')}
						&nbsp;
					</p>
				</td>
			);
		} else if (usedAt) {
			testDateInfo = (
				<td className="lit-test__col">
					<p className="lit-test-no-margin">
						{strings.started}
						<br />
						{moment(usedAt).format('LLL')}
						&nbsp;
					</p>
				</td>
			);
		} else if (distributedAt) {
			testDateInfo = (
				<td className="lit-test__col">
					<p className="lit-test-no-margin">
						{strings.distributed}
						<br />
						{moment(distributedAt).format('LLL')}
						&nbsp;
					</p>
				</td>
			);
		}

		return testDateInfo;
	}
	getFilteredTestUsers(classData, allTestUsers) {
		const allUsers = classData.map((data) => {
			return data.candidateId;
		});

		if (!this.state.isGroupPanelActive) {
			const tempObj = [];
			for (let i = 0; i < allTestUsers.length; i++) {
				const testsResults = allTestUsers[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}

			if (tempObj.length) {
				return tempObj;
			}
		} else if (this.state.isGroupPanelActive) {
			const {groupTestResults} = this.state;
			const tempObj = [];
			for (let i = 0; i < groupTestResults.length; i++) {
				const testsResults = groupTestResults[i].testResults;
				for (let j = 0; j < testsResults.length; j++) {
					if (testsResults[j].testUser) {
						if (
							allUsers.includes(
								testsResults[j].testUser.testUserId
							)
						) {
							tempObj.push(testsResults[j]);
						}
					}
				}
			}

			if (tempObj.length) {
				return tempObj;
			}
		}

		return null;
	}

	async getAndSetTestAdminGroupedClassTestResults(selectedGroup) {
		const selectedgroup = selectedGroup;
		if (selectedGroup !== '') {
			const testResults =
				await getGroupedTestAdminClassResults(selectedgroup);
			const batchedTestResults = await processTestResults(
				testResults.testResults,
				null
			);
			return await new Promise((resolve) => {
				this.setState(
					{
						allCandidates: testResults.testUsers,
						groupTestResults: batchedTestResults,
						isClassPanelActive: false,
					},
					resolve
				);
			});
		}
		return null;
	}
	getSelectedOwnedClasses() {
		return this.state.selectedClassData.filter(
			(classData) => classData.checked && classData.ownsClass
		);
	}

	getAvailableGroupsForClasses(classes = []) {
		const {userGroups = []} = this.props;

		if (!userGroups.length || !classes.length) {
			return [];
		}

		return userGroups.filter((group) => {
			if (!group || !group.id) return false;

			return classes.some(
				(classData) =>
					String(classData.groupId || '') !== String(group.id)
			);
		});
	}

	canAddSelectedClassesToGroup() {
		const selectedOwnedClasses = this.getSelectedOwnedClasses();
		const availableGroups =
			this.getAvailableGroupsForClasses(selectedOwnedClasses);

		return Boolean(selectedOwnedClasses.length && availableGroups.length);
	}
	showPaneAlert(message) {
		this.setState({
			renderPaneAlert: true,
			paneMessage: message,
		});
	}
	render() {
		const {selectedClassData} = this.state;
		const userGroups = this.props.userGroups || [];
		const hasUserGroups = Boolean(userGroups.length);
		const selectedOwnedClasses = this.getSelectedOwnedClasses();
		const availableGroups =
			this.getAvailableGroupsForClasses(selectedOwnedClasses);

		const groupOptions = availableGroups;
		const selectedGroupId =
			this.state.groupId || (groupOptions[0] && groupOptions[0].id) || '';

		return (
			<div className="mcx-page">
				<div className="lit-tests-view__header">
					{/* <div className="audio" id="audio"></div> */}
					<div className="lit-new-test__wrapper">
						<div className="lit-input-tab-grid">
							{
								<>
									{Boolean(selectedClassData.length) && (
										<button
											className="lit-mytests-header-mytest-btn-ternary"
											onClick={() => {
												const extractSelectedClasses =
													selectedClassData.filter(
														(data) => data.checked
													);

												if (
													!extractSelectedClasses.length
												) {
													this.showPaneAlert(
														strings.chooseclass
													);
													return;
												}

												let controlDeletion = false;

												const extractedIds =
													extractSelectedClasses
														.map((classData) => {
															if (
																classData.ownsClass
															) {
																return classData.classId;
															}

															controlDeletion = true;
															return null;
														})
														.filter(Boolean);

												const subsId =
													extractSelectedClasses[0]
														.subscription;

												if (controlDeletion) {
													this.showPaneAlert(
														'Det är inte tillåtet att radera en klass som inte är skapad av dig.'
													);
													return;
												}

												if (
													window.confirm(
														strings.formatString(
															strings.confirmationdeleteclass,
															`${
																extractedIds.length >
																1
																	? strings.multipleclasses
																	: strings.theclass
															}`
														)
													)
												) {
													this.deleteSelectedClasses(
														extractedIds,
														subsId
													);
												}

												this.setState({
													allMyClasses:
														'Alla mina klasser',
												});
											}}
										>
											<FontAwesomeIcon
												className="lit-icon-btns"
												icon={faTrash}
											/>
											<p className="lit-btns-txt-negative">
												{strings.deleteclass}
											</p>
										</button>
									)}
									{/*scrollers starting div*/}
									{this.state.renderPaneMessage && (
										<InformationPane
											paneMessage={this.state.paneMessage}
											onApproval={() => {
												this.setState({
													renderPaneMessage: false,
												});
											}}
											onCloseWindow={() => {
												this.setState({
													renderPaneMessage: false,
												});
											}}
											onDisproval={() => {
												this.setState({
													renderPaneMessage: false,
												});
											}}
											category={'information'}
										/>
									)}

									{Boolean(
										this.state.allClassData.length
									) && (
										<div className="lit-View_tests">
											<div className="lit-dropdown_filter">
												<select
													className="lit-input__field"
													value={
														this.state.allMyClasses
													}
													onChange={(e) => {
														const newClassData = [];
														if (
															e.target.value.includes(
																'groupTitle'
															)
														) {
															const newClassData =
																[];

															const classIds = [];
															let hasRelevantClasses = false;

															const extractedGroup =
																e.target.value.split(
																	'groupTitle'
																);
															const groupName =
																extractedGroup[
																	extractedGroup.length -
																		1
																];
															const chosenGroup =
																this.props.userGroups.filter(
																	(group) =>
																		group.name ===
																		groupName
																);
															this.getAndSetTestAdminGroupedClassTestResults(
																chosenGroup[0]
																	.id
															);
															for (
																let i = 0;
																i <
																this.state
																	.allClassData
																	.length;
																i++
															) {
																if (
																	this.state
																		.allClassData[
																		i
																	].groupId &&
																	chosenGroup[0]
																		.id ===
																		this
																			.state
																			.allClassData[
																			i
																		]
																			.groupId
																) {
																	newClassData.push(
																		this
																			.state
																			.allClassData[
																			i
																		]
																	);
																	hasRelevantClasses = true;
																}
															}
															this.setState({
																allMyClasses:
																	e.target
																		.value,
																isGroupPanelActive: true,
																hasRelevantClasses:
																	hasRelevantClasses,
																selectedClassData:
																	newClassData,
																groupClassData:
																	newClassData,
																selectedGroup:
																	chosenGroup,
															});
														} else {
															let hasRelevantClasses = false;
															const checkedClassData =
																this.props.testUsers.map(
																	(data) => {
																		data.checked = false;
																		return data;
																	}
																);
															for (
																let i = 0;
																i <
																this.state
																	.allClassData
																	.length;
																i++
															) {
																if (
																	!this.state
																		.allClassData[
																		i
																	].groupId ||
																	this.state
																		.allClassData[
																		i
																	].ownsClass
																) {
																	newClassData.push(
																		this
																			.state
																			.allClassData[
																			i
																		]
																	);
																	hasRelevantClasses = true;
																}
															}

															this.setState({
																isGroupPanelActive: false,
																hasRelevantClasses:
																	hasRelevantClasses,
																selectedClassData:
																	newClassData,
																allMyClasses:
																	allMyClasses,
															});
														}
													}}
												>
													<option
														key={1}
														value="Alla mina klasser"
													>
														{'Alla mina klasser'}
													</option>
													{Boolean(
														this.props.userGroups
															.length
													) && (
														<option
															className="label_grupper-option"
															disabled="disabled"
														>
															{
																'---Klasser i grupper---'
															}
														</option>
													)}
													{Boolean(
														this.props.userGroups
															.length
													) &&
														this.props.userGroups.map(
															(groups, index) => (
																<option
																	id={`groups${groups.id}`}
																	key={
																		groups.id
																	}
																	value={`groupTitle${groups.name}`}
																>
																	{
																		groups.name
																	}
																</option>
															)
														)}
												</select>
											</div>
										</div>
									)}

									{this.state.isAddingClassToGroup && (
										<div className="mcx-group-picker">
											<label className="mcx-group-picker__label">
												Välj grupp
											</label>

											<select
												className="mcx-group-picker__select"
												value={selectedGroupId}
												onChange={(e) => {
													this.setState({
														groupId: e.target.value,
													});
												}}
											>
												{groupOptions.map((group) => (
													<option
														key={group.id}
														value={group.id}
													>
														{group.name}
													</option>
												))}
											</select>
										</div>
									)}

									{Boolean(selectedClassData.length) && (
										<button
											className={classNames(
												'lit-mytests-header-mytest-btn-secondary',
												{
													'lit-btn--disabled':
														!hasUserGroups,
												}
											)}
											onClick={() => {
												const selectedOwnedClasses =
													this.getSelectedOwnedClasses();
												const userGroups =
													this.props.userGroups || [];
												const availableGroups =
													this.getAvailableGroupsForClasses(
														selectedOwnedClasses
													);

												if (
													!selectedOwnedClasses.length
												) {
													this.showPaneAlert(
														strings.chooseclass
													);
													return;
												}

												if (!userGroups.length) {
													this.showPaneAlert(
														strings.nogroupcreateone
													);
													return;
												}

												if (!availableGroups.length) {
													this.showPaneAlert(
														strings.classingroupalready
													);
													return;
												}

												if (
													!this.state
														.isAddingClassToGroup
												) {
													const classIds =
														selectedOwnedClasses.map(
															(classData) =>
																classData.classId
														);

													this.setState({
														isAddingClassToGroup: true,
														selectedClasses:
															classIds,
														groupId:
															availableGroups[0]
																.id,
														renderPaneAlert: false,
														paneMessage: '',
													});

													return;
												}

												if (!this.state.groupId) {
													this.showPaneAlert(
														'Välj grupp'
													);
													return;
												}

												this.addSelectedClassesToGroup(
													this.state.selectedClasses,
													this.state.groupId
												);
											}}
										>
											<FontAwesomeIcon
												className="lit-icon-btns"
												icon={faPlus}
											/>
											<p className="lit-btns-txt">
												{!this.state
													.isAddingClassToGroup
													? strings.addtogroup
													: ' Lägg till'}
											</p>
										</button>
									)}
								</>
							}
						</div>
					</div>
				</div>

				<div className="lit-tests-view__contant">
					<div className="lit-btn_grid">
						{(!this.state.selectedClassData.length ||
							!this.state.hasRelevantClasses) && (
							<p>{strings.message_noclasses}</p>
						)}

						{this.state.hasRelevantClasses &&
							Boolean(this.state.selectedClassData.length) && (
								<div className="lit-main-candidates-contianer">
									<div className="lit_myClass_table-wrapper">
										{this.renderCustomTableHeader()}

										{selectedClassData.map(
											(data, index) => {
												if (
													!this.state
														.isGroupPanelActive
												) {
													if (
														!data.groupId ||
														data.ownsClass
													) {
														return (
															<div key={index}>
																{this.renderCustomTable(
																	data
																)}
															</div>
														);
													}
												} else {
													if (data.groupId) {
														return (
															<div key={index}>
																{this.renderCustomTable(
																	data
																)}
															</div>
														);
													}
												}
											}
										)}
									</div>
								</div>
							)}
					</div>

					{this.state.renderPaneAlert && (
						<InformationPane
							paneMessage={
								this.state.paneMessage || strings.chooseclass
							}
							onApproval={() => {
								this.setState({
									renderPaneAlert: false,
									paneMessage: '',
								});
							}}
							onCloseWindow={() => {
								this.setState({
									renderPaneAlert: false,
									paneMessage: '',
								});
							}}
							onDisproval={() => {
								this.setState({
									renderPaneAlert: false,
									paneMessage: '',
								});
							}}
							category={'information'}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default MyClasses;
